var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#84D5DC",
    fillOpacity: 0.1,
    stroke: "#51A3AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15625 6.24951C5.57617 6.24951 5.125 6.72217 5.125 7.28076V8.65576C5.125 8.84912 5.27539 8.99951 5.46875 8.99951H7.1875V7.28076C7.1875 6.72217 6.71484 6.24951 6.15625 6.24951ZM10.625 15.1226V13.812H16.8125V8.31201C16.8125 7.19482 15.8672 6.24951 14.75 6.24951H7.50977C7.72461 6.55029 7.875 6.89404 7.875 7.28076V15.187C7.875 16.0249 8.60547 16.6909 9.46484 16.562C10.1523 16.4331 10.625 15.8101 10.625 15.1226ZM11.3125 14.4995V15.187C11.3125 16.3257 10.3672 17.2495 9.25 17.2495H16.4688C17.7793 17.2495 18.875 16.1753 18.875 14.8433C18.875 14.6714 18.7031 14.4995 18.5312 14.4995H11.3125Z",
    fill: "#51A3AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMat);
export default __webpack_public_path__ + "static/media/mat.08d673a919e7a4a8c7d3f9192708a282.svg";
export { ForwardRef as ReactComponent };